import { OWL, EASYBIB, CITATION_MACHINE, CHEGG, BIBME, CHEGG_SIHP, ButtonAttributes } from '../types'
import { StoreState } from '../reducer/types'
import { owl } from '../../src/containers/DocumentTextarea.css'
import { wrapper, positionRelativeBounding, owlBounding } from '../../src/containers/App.css'
import {
  subText,
  owlSubtext,
  cheggSihpSubtext,
  paperUploadUi,
  owlPaperUploadUi,
  cheggSihpPaperUploadUi,
  cheggSihpHeading,
} from '../../src/containers/UploadOptions.css'
import { fanta } from '@chegg/fanta'
export const OWL_UTM_PARAMS = '&utm_source=owl&utm_medium=ulw&utm_campaign=version2'
export const CHEGG_SIHP_UTM_PARAMS = 'utm_source=sihp&utm_medium=ulw&utm_campaign=version2'

export const selectSite = (state: StoreState) => state.site
export const selectCollapsed = (state: StoreState) => (state.site === OWL ? true : false)
export const selectRelativeBounding = (state: StoreState) =>
  state.site === OWL ? [positionRelativeBounding, owlBounding].join(' ') : positionRelativeBounding
export const selectHeadingClass = (state: StoreState) => (state.site === CHEGG_SIHP ? cheggSihpHeading : '')
export const selectButtonClass = (state: StoreState) => (state.site === OWL ? owl : {})
export const selectDisplayLegal = (state: StoreState) =>
  state.site === OWL || state.site === CHEGG_SIHP ? false : true
export const selectWrapperClass = (state: StoreState) =>
  state.site === OWL || state.site === CHEGG_SIHP ? {} : wrapper

export const selectUtmQueryParams = (state: StoreState) => {
  switch (state.site) {
    case OWL:
      return OWL_UTM_PARAMS
    case CHEGG_SIHP:
      return CHEGG_SIHP_UTM_PARAMS
    default:
      return ''
  }
}

export const selectTermsAndConditionsUrl = (state: StoreState) => {
  switch (state.site) {
    case EASYBIB:
      return `https://writing.easybib.com/free-trial-terms-and-conditions`
    case CITATION_MACHINE:
      return `https://writing.citationmachine.net/free-trial-terms-and-conditions`
    case CHEGG:
      return `https://writing.chegg.com/free-trial-terms-and-conditions`
    case BIBME:
      return `https://writing.bibme.org/free-trial-terms-and-conditions`
    default:
      return `https://writing.chegg.com/free-trial-terms-and-conditions`
  }
}

export const selectUploadUiClass = (state: StoreState) => {
  switch (state.site) {
    case OWL:
      return [paperUploadUi, owlPaperUploadUi].join(' ')
    case CHEGG_SIHP:
      return [paperUploadUi, cheggSihpPaperUploadUi].join(' ')
    default:
      return paperUploadUi
  }
}

export const selectSubtextClass = (state: StoreState) => {
  switch (state.site) {
    case OWL:
      return [subText, owlSubtext].join(' ')
    case CHEGG_SIHP:
      return [subText, cheggSihpSubtext].join(' ')
    default:
      return subText
  }
}

export const selectButtonAttributes = (state: StoreState): ButtonAttributes => {
  switch (state.site) {
    case OWL: {
      return {
        buttonColor: '#D78540',
        buttonHoverColor: '#D46E00',
        buttonTextColor: fanta.colors.white,
        buttonDisabledColor: '#D78540',
        buttonDisabledTextColor: fanta.colors.white,
        disabledOpacity: '50%',
        borderRadius: '8px',
      }
    }
    case BIBME: {
      return {
        buttonColor: '#228EB5',
        buttonHoverColor: '#196E89',
        buttonTextColor: fanta.colors.white,
      }
    }
    case CITATION_MACHINE: {
      return {
        buttonColor: '#D78541',
        buttonHoverColor: '#AC6A34',
        buttonTextColor: fanta.colors.white,
      }
    }
    case CHEGG_SIHP: {
      return {
        buttonColor: '#21a29d',
        buttonHoverColor: '#188e87',
        buttonTextColor: fanta.colors.white,
        borderRadius: '8px',
        fontSize: '20px',
      }
    }
    case EASYBIB:
    default:
      return {
        buttonColor: fanta.colors.cheggOrange,
        buttonHoverColor: fanta.colors.orangeDark,
        buttonTextColor: fanta.colors.white,
        buttonDisabledColor: fanta.colors.greyLight,
        buttonDisabledTextColor: fanta.colors.greyMedium,
      }
  }
}
